import React, { useMemo } from 'react';
import StandardQuickFilters from '../StandardComponents/StandardQuickFilters/StandardQuickFilters';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';

const defaultColors = {
  active: { bg: '#EFF6FF', text: '#1E40AF', border: '#3B82F6' },
  default: { bg: '#F9FAFB', text: '#374151', border: '#E5E7EB' },
  hover: { bg: '#EFF6FF', text: '#1E40AF', border: '#3B82F6' },
};

const activeColors = {
  active: { bg: '#EBFFF8', text: '#065F46', border: '#00CC85' },
  default: { bg: '#F9FAFB', text: '#374151', border: '#E5E7EB' },
  hover: { bg: '#EBFFF8', text: '#065F46', border: '#00CC85' },
};

const inactiveColors = {
  active: { bg: '#F3F4F6', text: '#374151', border: '#9CA3AF' },
  default: { bg: '#F9FAFB', text: '#374151', border: '#E5E7EB' },
  hover: { bg: '#F3F4F6', text: '#374151', border: '#9CA3AF' },
};

/**
 * UnlockCodesQuickFilters — active/inactive and usage quick filters for unlock codes.
 */
export default function UnlockCodesQuickFilters({ codes = [], activeFilters = {}, onApplyFilter }) {
  const filters = useMemo(() => [
    {
      label: 'Active',
      field: 'is_active',
      value: true,
      count: codes.filter((c) => c.is_active).length,
      colors: activeColors,
      icon: <CheckCircleOutlineIcon sx={{ fontSize: 18, color: '#00CC85' }} />,
    },
    {
      label: 'Inactive',
      field: 'is_active',
      value: false,
      count: codes.filter((c) => !c.is_active).length,
      colors: inactiveColors,
      icon: <BlockIcon sx={{ fontSize: 18, color: '#9CA3AF' }} />,
    },
    {
      label: 'Unused',
      field: 'unused',
      value: true,
      count: codes.filter((c) => (c.used_count ?? 0) === 0).length,
      colors: defaultColors,
      icon: <NewReleasesOutlinedIcon sx={{ fontSize: 18, color: '#3B82F6' }} />,
    },
    {
      label: 'Has Redemptions',
      field: 'has_uses',
      value: true,
      count: codes.filter((c) => (c.used_count ?? 0) > 0).length,
      colors: defaultColors,
      icon: <RedeemOutlinedIcon sx={{ fontSize: 18, color: '#3B82F6' }} />,
    },
  ], [codes]);

  return (
    <StandardQuickFilters
      title="Quick Filters"
      filters={filters}
      activeFilters={activeFilters}
      onApplyFilter={onApplyFilter}
    />
  );
}
